import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowCircleDownFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 21.7501C17.3852 21.7501 21.7501 17.3852 21.7501 12C21.7501 6.61483 17.3852 2.24994 12 2.24994C6.61483 2.24995 2.24995 6.61483 2.24995 12C2.24995 17.3852 6.61483 21.7501 12 21.7501ZM15.7123 13.591C16.0052 13.2981 16.0052 12.8232 15.7123 12.5303C15.4194 12.2374 14.9446 12.2374 14.6517 12.5303L12.75 14.432L12.75 7.75737C12.75 7.34315 12.4142 7.00737 12 7.00736C11.5858 7.00736 11.25 7.34315 11.25 7.75736L11.25 14.432L9.34836 12.5303C9.05546 12.2374 8.58059 12.2374 8.2877 12.5303C7.9948 12.8232 7.9948 13.2981 8.2877 13.591L11.4697 16.773C11.7626 17.0659 12.2374 17.0659 12.5303 16.773L15.7123 13.591Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgArrowCircleDownFilled);
export default ForwardRef;
